import type { FilterConfig } from '@/lib/merge-stream/types'
import type { MarketListItem } from '@/types/market'

export function countActiveFilters(filters: FilterConfig): number {
	let count = 0
	// if (filters.categories?.length) {
	// 	count += filters.categories.length
	// }
	if (filters.tradableOnly) {
		count++
	}
	if (filters.activeOnly === false) {
		count++
	}
	// Volume range counts as 1 filter (whether min, max, or both are set)
	if (filters.minVolume !== undefined || filters.maxVolume !== undefined) {
		count++
	}
	// Liquidity range counts as 1 filter (whether min, max, or both are set)
	if (filters.minLiquidity !== undefined || filters.maxLiquidity !== undefined) {
		count++
	}
	if (filters.closingTime) {
		count++
	}
	if (filters.minProbability !== undefined) {
		count++
	}
	return count
}

export const getMarketUrl = (market: Partial<MarketListItem>, side?: 'yes' | 'no'): string => {
	const platformRoutes: Record<string, string> = {
		polymarket: '/poly',
		opinionlabs: '/opinion',
		kalshi: '/kalshi',
		predictfun: '/predict',
		myriad: '/myriad',
		limitless: '/limitless',
	}

	const routePrefix = platformRoutes[market.platform || 'kalshi'] || '/kalshi'

	// Use parentEventSlug if available, otherwise use eventId
	const path = market.parentEvent?.parentEventSlug
		? `/v2/${routePrefix}/${market.parentEvent.parentEventSlug}?marketId=${market.id}`
		: `/v2/${routePrefix}/${market.eventId}`

	// Append side parameter if provided
	return side ? `${path}${path.includes('?') ? '&' : '?'}side=${side}` : path
}
